<template>
  <div class="">
    <div class="head-title">
      订单列表
    </div>
    <div class="">
      <div>
        <el-table
          border
          v-loading="tableLoading"
          :data="tableData"
          height="640"
        >
          <el-table-column label="客户信息" width="180">
            <template slot-scope="scope">
              <div class="person">
                <el-avatar :src="scope.row.logo" @error="errorHandler">
                  <img
                    src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
                  />
                </el-avatar>
                <span class="name">{{ scope.row.nickname }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="gmtCreate" label="成为客户时间">
            <template slot-scope="scope">
              <div>{{ scope.row.gmtCreate | formatDate }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="mail" label="邮箱"></el-table-column>
          <el-table-column
            prop="currentPoint"
            label="当前积分"
          ></el-table-column>
          <el-table-column
            prop="currentAmount"
            label="当前余额"
          ></el-table-column
          >>
          <el-table-column fixed="right" label="操作" style="width: 20%">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="onDetail(scope.row)"
                size="small"
                style="color: #2890dd"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          @prev-click="onPrev"
          @next-click="onNext"
          :page-size="size"
          :page-sizes="[10,20, 50, 100]"
          layout="sizes,next"
          prev-text="上一页"
          next-text="下一页"
          style="padding:2rem 0;"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "customerList",
  data() {
    return {
      tableData: [],
      accesstoken: "",
      size: 20,
      cursor: 0,
      tableLoading: true,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.cheshi();
  },
  methods: {
    cheshi() {
      this.axios
        .post(
          "/weimob/index/check_secret",
          qs.stringify({
            phone: this.tooken.phone,
            account_id: this.tooken.account_id,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.code == 0) {
            // this.$router.push("/register/user/order");
          }
          if (res.data.code == 1) {
            this.axios
              .post(
                "/weimob/index/get_access_token",
                qs.stringify({
                  phone: this.tooken.phone,
                  account_id: this.tooken.account_id,
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.accesstoken = res.data.data;
                  this.userTable();
                }
                if (res.data.code == 0) {
                  // this.$router.push("/register/user/order");
                }
              })
              .catch(function (err) {});
          }
        })
        .catch(function (err) {});
    },
    handleCurrentChange() {},
    handleSizeChange(size) {
      if (this.cursor === null) {
        return;
      }
      this.cursor = 0;
      this.size = size;
      this.userTable();
    },
    onPrev(currentPage) {
      this.cursor = this.cursor - this.size * 2;
      this.userTable();
    },
    onNext(currentPage) {
      if (this.cursor === null) {
        return;
      }
      this.userTable();
    },
    //获取页面数据
    userTable() {
      const cursorObj = {
        cursor: this.cursor,
      };
      let params = {
        size: this.size,
        queryParameter: {},
        accesstoken:
          "https://dopen.weimob.com/api/1_0/mc/member/getMemberList?accesstoken=" +
          this.accesstoken,
      };
      if (cursorObj.cursor) {
        params = Object.assign(params, cursorObj);
      }
      this.tableData = [];
      this.axios
        .post("/weimob/index/http_send", qs.stringify(params), {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((res) => {
          this.tableLoading = false;
          this.tableData = res.data.data.items;
          this.cursor = res.data.data.cursor;
        })
        .catch(function (err) {});
    },
    errorHandler() {
      return true;
    },
    onDetail(row) {
      this.$router.push({
        name: "customerDetail",
        query: {
          id: row.wid,
        },
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}
.body_html {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0 .1rem .6rem 0 rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 2.6rem;
}

/* 表单 */
.person {
  display: inline-flex;
  align-items: center;
}
.person .name {
  margin-left: .8rem;
}
</style>

